import { render } from "./ProductGallery.vue?vue&type=template&id=7a354173&scoped=true"
import script from "./ProductGallery.js?vue&type=script&lang=js"
export * from "./ProductGallery.js?vue&type=script&lang=js"

import "./ProductGallery.scss?vue&type=style&index=0&id=7a354173&lang=scss&scoped=true"

import exportComponent from "/Users/irshadck/projects/sunrise-spa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a354173"]])

export default __exports__